import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import TextField from 'material-ui/TextField';
import {Link} from 'react-router';
import {observer} from 'mobx-react';


const contentStyle = {
  width: '500px',
  maxWidth: '100%',
};
/**
 * Dialogs can be nested. This example opens a Date Picker from within a Dialog.
 */
@observer(['state','actions'])
export default class LoginModal extends React.Component {
  state = {
    email: "",
    password: "",
  };

  emailErr = "";
  passwordErr = "";
  errorMsg = 'this field is required';
  errorMsgEmail = 'Email not valid';

  // handleOpen = () => {
  //   this.setProps({open: true});
  // };

  // handleClose = () => {
  //   this.setProps({open: false});
  // };
  checkEmailAddress(email){
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  checkInput(){

    this.emailErr = "";
    this.passwordErr = "";

    if(!this.state.email || !this.state.password || !this.checkEmailAddress(this.state.email) ){

      if(!this.state.email || !this.checkEmailAddress(this.state.email)) this.emailErr = this.errorMsgEmail;
      if(!this.state.password) this.passwordErr = this.errorMsg;
      this.forceUpdate();
      return false;
    }
    else{

      this.forceUpdate();
      return true;
    }
  }

  handleSubmit(event){
    event.preventDefault();
    if(this.checkInput()){
      this.login();
    }
  }

  handleChange(fieldName,event) {

    var change = {};
    change[fieldName] = event.target.value;
      this.setState(change);
  }

  login = function(){
    var _this = this;
    var login_data = {
      email:this.state.email,
      method:1,
      password:this.state.password,
      remember_me:false
    }
    this.props.actions.auth.old_login(login_data).then(function(res){
      // _this.sentSuccess(res);
      console.log(res);
      var origin = window.location.protocol + "//" + window.location.host;
      if (window.location.hostname.indexOf('.local') > -1) {
        window.location.assign('http://tipigo.local/app/dist/index.html#/');
      }
      else {
        window.location.assign(origin + '/app/dist/index.html#/');
      }

    },function(err){
      // _this.sentError(err);
      console.log("somthing went wrong");
    });
  }

  render() {
    // const actions = [
    //   <FlatButton
    //     label="Ok"
    //     primary={true}
    //     keyboardFocused={true}
    //     onTouchTap={this.handleClose}
    //   />,
    // ];

    // <div>
    //   <RaisedButton label="Dialog With Date Picker" onTouchTap={this.handleOpen} />
    //   </div>

    return (

        <Dialog

          modal={false}
          open={this.props.open}
          onRequestClose={this.props.handleClose}
          contentStyle={contentStyle}
        >

        {/*<button onClick={this.props.handleClose} className="pull-right clean_btn close_btn"><img src={require("../../img/x_icon.png")}/></button>*/}
        <div className="modal_content login_modal">
          <h3 className="text-center">Tipigo Login</h3>
          <br/>
          <form  onSubmit={this.handleSubmit.bind(this)}>
          <TextField
            className="tipigo_bright_input"
            underlineFocusStyle={{"borderColor":"#47b927"}}
            value={this.state.email}
            fullWidth
            onChange={this.handleChange.bind(this,'email')}
            errorText={this.emailErr}
            autoFocus
            floatingLabelText="Email"/>
          <TextField
            className="tipigo_bright_input"
            underlineFocusStyle={{"borderColor":"#47b927"}}
            value={this.state.password}
            fullWidth
            type="password"
            onChange={this.handleChange.bind(this,'password')}
            errorText={this.passwordErr}
            floatingLabelText="Password"/>
          <br/>
          <br/>
          <RaisedButton type="submit"  className="feedback_btn" fullWidth label="LOGIN" labelColor="white" backgroundColor="rgb(71,185,39)" />
          </form>
          <br/>
          <br/>
          <br/>
          <Link href="" className="forgotp_link">Forgot password?</Link>  <div className="pull-right"><span>Don't have an account?</span> <Link onTouchTap={this.props.handleClose} to="contact_us">Contact us</Link></div>
          <br/>
          <br/>

        </div>
        </Dialog>

    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/LoginModal.js